const profile = {
    name: '名稱',
    avatar: '頭像',
    givenName: '名字',
    familyName: '姓氏',
    middleName: '中間名',
    fullname: '全名',
    nickname: '暱稱',
    preferredUsername: '偏好用戶名',
    profile: '個人資料',
    website: '網站',
    gender: '性別',
    birthdate: '出生日期',
    zoneinfo: '時區',
    locale: '語言地區',
    address: {
        formatted: '地址',
        streetAddress: '街道地址',
        locality: '城市',
        region: '州／省份',
        postalCode: '郵遞區號',
        country: '國家',
    },
    gender_options: {
        female: '女性',
        male: '男性',
        prefer_not_to_say: '不願透露',
    },
    checkbox_value: {
        checked: '是',
        unchecked: '否',
    },
};
export default Object.freeze(profile);
